import styled from 'styled-components'

export const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;

  .file-name-placeholder {
    color: #cbcbcb !important;
    font-weight: 300;
  }
`

export const TitleAndDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > label {
    font-size: 1rem;
    font-weight: 600;
  }

  > p {
    font-size: 0.875rem;
    font-weight: 400;
    color: #3d3d3d;
  }
`

export const InvisibleFileInput = styled.input`
  display: none;
`

interface FakeFileInputProps {
  hasError: boolean
}
export const FakeFileInput = styled.label<FakeFileInputProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  height: auto;
  padding: 0.75rem;
  cursor: pointer;

  border: 1px solid ${({ hasError }) => (hasError ? '#e24444' : '#d9d9d9')};
  border-radius: 0.5rem;
  transition: 0.5s;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    min-width: 1.5rem;
    min-height: 1.5rem;
  }

  &:hover {
    border: 1px solid #21976e;
  }
`

export const FileInputErrorMessage = styled.p`
  font-size: 1rem;
  color: #e24444;
  margin-top: -0.5rem;
  font-weight: 300;
`
